export const RELOAD_AUTH_ACCOUNTS_DATA = "authAccounts/reload"

export const reloadAuthAccountsData = () => ({
    type: RELOAD_AUTH_ACCOUNTS_DATA,
})
